module.exports = __webpack_public_path__ + "img/pr-6.df8d4d40.png";